export function useQmoduleProps() {
  return {};
}
